// Copy de la sección «Poderes del chat», copiado tal cual de Poderes_Chat (escritorio) y
// Poderes_Chat_Movil (móvil). El móvil tiene textos más cortos y solo se pintan en su árbol
// (UI-SPEC §Layout frame «Two-composition pieces»). Los nombres y descripciones de las funciones
// NO van aquí: salen del catálogo del asistente (D-22).

export interface TarjetaPoderes {
    readonly titulo: string;
    readonly texto: string;
}

export const TEXTOS_PODERES = {
    antetitulo: 'Los poderes del asistente',
    titulo: 'Pídeselo al chat.',
    tituloResaltado: 'Tú decides.',
    entradilla:
        'Once funciones dentro de un chat que conoce todo el historial de tu paciente. Responde citando de dónde sale cada dato y no cambia tu plan sin tu aprobación.',
    entradillaMovil:
        'Once funciones en un chat que conoce todo el historial de tu paciente. Cita de dónde sale cada dato y no cambia tu plan sin tu aprobación.',
    etiquetaFunciones: 'Funciones del asistente',
    etiquetaGrupos: 'Grupos de funciones',
    cta: { texto: 'Pruébalo con tus pacientes', href: '/app/register' },
    enlacePagina: { texto: 'Ver todos los poderes del chat', href: '/funcionalidades/chatbot-con-historial-clinico' },
} as const;

export const TARJETAS_PODERES: readonly TarjetaPoderes[] = [
    {
        titulo: 'Cita la fuente',
        texto: 'Cada respuesta dice de qué sesión o documento sale. Tocas la cita y lo compruebas.',
    },
    {
        titulo: 'Propone; tú decides',
        texto: 'Los cambios en el plan llegan como propuesta: los apruebas, los editas o los rechazas.',
    },
    {
        titulo: 'Ves qué hace en cada paso',
        texto: 'Mientras trabaja te dice qué está leyendo. Y puedes arrastrar documentos al chat.',
    },
];

export const TARJETAS_PODERES_MOVIL: readonly TarjetaPoderes[] = [
    { titulo: 'Cita la fuente', texto: 'Cada respuesta dice de qué sesión o documento sale.' },
    { titulo: 'Propone; tú decides', texto: 'Los cambios en el plan los apruebas, los editas o los rechazas.' },
    { titulo: 'Ves qué hace en cada paso', texto: 'Te dice qué está leyendo mientras trabaja.' },
];
